import { Button, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { MobileTitle } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { responsiveMargin } from '../../../../utils/enum';
import { typeDefaultValue, typeSchema } from '../Common/DefaultValuesAndSchema';
import { EditTypeForm } from '../Common/EditCategoryForm';
import { GoBackIconButton } from './GoBackIconButton';

export default function EditTypeCategoryMobile() {
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...typeSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...typeDefaultValue,
    },
    shouldUnregister: false,
  });

  const [putCategoryResult, putCategory] = useAuthAxios({
    method: 'PUT',
    url: `/api/v1/category/${categoryId}`,
  });
  const onSubmit = form.handleSubmit(function (values) {
    const data = new FormData();
    data.append('categoryId', values.categoryId);
    data.append('categoryType', values.categoryType);
    data.append('title', values.title);
    data.append('notes', values.notes);
    data.append('file', values.file);

    putCategory({ data });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GoBackIconButton form={form} />
        <MobileTitle>구분 수정</MobileTitle>
        <Button variant="text" onClick={onSubmit}>
          수정
        </Button>
        <ApiResultModal
          apiResult={putCategoryResult}
          successTitle="수정됐습니다."
          successCode={200}
          onSuccessClose={() => {
            navigate(`/category`);
          }}
          failTitle="관리자에게 문의해주세요."
          ErrorCodeTable={{
            PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          }}
        />
      </Stack>
      <EditTypeForm form={form} categoryId={categoryId} />
    </Stack>
  );
}
